// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-1f14a18a] .vxe-table--body-wrapper {\r\n  height: 300px !important;\n}\n[data-v-1f14a18a] .vxe-table--empty-placeholder {\r\n  height: 300px !important;\n}\r\n\r\n", ""]);
// Exports
module.exports = exports;
